import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Payment.css";

export default function KakaoBillingFail() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const errorMessage = params.get("message") || t("payment.cancelMessage");

  return (
    <div className="payment-result-page">
      <div className="payment-result-card">
        <div className="payment-icon cancel">X</div>
        <h1>{t("payment.cancelTitle")}</h1>
        <p>{errorMessage}</p>
        <button className="btn-primary" onClick={() => history.push("/pricing")}>
          {t("nav.pricing")}
        </button>
      </div>
    </div>
  );
}
